module.exports = __webpack_public_path__ + "static/media/crown.c70149ec.svg";